import { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

const unknownText = "unbekannt";

function formatBuildDate(value) {
  if (!value) return unknownText;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return unknownText;
  return new Intl.DateTimeFormat("de-DE", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date);
}

function DetailRow({ label, value }) {
  return <Box sx={{ display: "grid", gridTemplateColumns: "100px 1fr", gap: 1, py: 0.25 }}>
    <Typography component="dt" variant="body2" sx={{ fontWeight: 600 }}>{label}</Typography>
    <Typography component="dd" variant="body2" sx={{ m: 0, overflowWrap: "anywhere" }}>{value}</Typography>
  </Box>;
}

export default function VersionInfo() {
  const [info, setInfo] = useState(null);
  const [failed, setFailed] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const response = await window.fetch(`${process.env.PUBLIC_URL || ""}/version.json`, { cache: "no-store" });
        if (!response.ok) throw new Error("Version information unavailable");
        const data = await response.json();
        if (!data?.fullVersion) throw new Error("Invalid version information");
        if (mounted) setInfo(data);
      } catch {
        if (mounted) setFailed(true);
      }
    };
    load();
    return () => { mounted = false; };
  }, []);

  const label = info?.fullVersion
    ? `Version ${info.fullVersion}`
    : failed ? "Version unbekannt" : "Version wird geladen";
  const applicationName = document.title || unknownText;

  return <>
    <Button
      variant="text"
      size="small"
      onClick={() => setOpen(true)}
      sx={{
        display: "block",
        minWidth: 0,
        mt: 0.25,
        mx: 0.75,
        px: 1,
        py: 0,
        color: "text.disabled",
        fontSize: "0.625rem",
        fontWeight: 400,
        lineHeight: 1.4,
        textAlign: "left",
        "&:hover": { bgcolor: "transparent", color: "text.secondary", textDecoration: "underline" },
      }}
    >
      {label}
    </Button>
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Versionsinformationen</DialogTitle>
      <DialogContent>
        <Box component="dl" sx={{ m: 0 }}>
          <DetailRow label="Anwendung" value={applicationName} />
          <DetailRow label="Version" value={info?.fullVersion || unknownText} />
          <DetailRow label="Umgebung" value={info?.environment || unknownText} />
          <DetailRow label="Git-Commit" value={info?.commit || unknownText} />
          <DetailRow label="Erstellt am" value={formatBuildDate(info?.buildDate)} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Schließen</Button>
      </DialogActions>
    </Dialog>
  </>;
}
